export default (state = { dragging: false, html: { id: null, value: null, size: 30, dir: 'bottom' } }, action) => {
  switch (action.type) {
    case "NECESSITY_SAVING": {
      return {
        ...state,
        necessitySaving: true,
        errorOnSaving: false,
      };
    }
    case "START_SAVING": {
      return {
        ...state,
        necessitySaving: false,
        savingInProgress: 'progress',
      };
    }
    case "FINISH_SAVING": {
      return {
        ...state,
        savingInProgress: false,
        errorOnSaving: false,
        necessitySaving: false,
      };
    }
    case "ERROR_SAVING": {
      return {
        ...state,
        savingInProgress: false,
        errorOnSaving: true
      };
    }
    case "FAIL": {
      return {
        ...state,
        fail: action.payload
      };
    }
    case "FAIL/CONFLICT": {
      return {
        ...state,
        fail: action.payload,
        fail_button: 'refresh'
      };
    }
    case "FAIL/JSON": {
      return {
        ...state,
        fail: action.payload,
        fail_reason: 'json',
        fail_button: 'refresh'
      };
    }
    case "DRAGGING/BEGIN": {
      return { ...state, dragging: true };
    }
    case "DRAGGING/END": {
      return { ...state, dragging: false };
    }
    case "APP/HTML/OPEN": {
      const { id, value } = action.payload;
      return { ...state, html: { ...state.html, id, value }};
    }
    case "APP/HTML/UPDATE": {
      const value = action.payload;
      return { ...state, html: { ...state.html, value }};
    }
    case "APP/HTML/CLOSE": {
      return { ...state, html: { ...state.html, id: null, value: null }};
    }
    case "APP/HTML/RESIZE": {
      const size = action.payload;
      return { ...state, html: { ...state.html, size }};
    }
    case "APP/HTML/BOTTOM": {
      return { ...state, html: { ...state.html, dir: 'bottom' }};
    }
    case "APP/HTML/LEFT": {
      return { ...state, html: { ...state.html, dir: 'left' }};
    }
    case "APP/PREVIEW/LIGHT": {
      return { ...state, preview_mode: 'light' };
    }
    case "APP/PREVIEW/DARK": {
      return { ...state, preview_mode: 'dark' };
    }
    case "APP/THEME/MODE": {
      return { ...state, theme_mode: action.payload };
    }
    default: {
      return state;
    }
  }
};
